module.exports = __webpack_public_path__ + "static/media/chinese_03.fd8ff325.jpg";